// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table__tableWrapper--2VT","topWinner":"Table__topWinner--nSw","top-winners-table":"Table__top-winners-table--1oV"};